

















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Newsitem extends Vue {
  @Prop() private sn!: number;
  @Prop() private item!: object;

  private gotoNewsDetailPage(id: string) {
    // window.console.log(id);
    this.$router.push(`/newslist/${id}`);
  }
}
